/**
 * Skeletons for the result list, one per view.
 *
 * Shaped to match the real rows so the list doesn't reflow when data arrives:
 * the same 56px thumbnail and the same two text lines in list view, the same
 * 108px image in card view.
 *
 * The legacy `ListLoader` also wrapped these in a header built from `col-4`,
 * `d-flex` and `placeholder animated` — Bootstrap classes that the Tailwind
 * config never defined, so it rendered as a stack of unstyled empty divs. Only
 * the rows are ported.
 */

function Line({ className }: { className: string }) {
  return <div className={`animate-pulse rounded bg-gray-300 ${className}`} />;
}

function ListItemLoader() {
  return (
    <div className="mr-1 flex items-center border-b border-opacity-10 bg-white pl-5 pr-5 md:max-w-[98%] md:flex-row dark:border-b-0 dark:bg-dark-color">
      <Line className="h-14 w-14" />
      <div className="ms-4 flex flex-grow flex-col justify-between p-4 leading-normal">
        <Line className="mb-2 h-5 w-3/4" />
        <Line className="h-4 w-1/2" />
      </div>
    </div>
  );
}

function CardItemLoader() {
  return (
    <div className="w-full bg-white px-2 py-6 transition-all duration-300 dark:bg-dark-color">
      <Line className="h-[108px] w-full" />
      <div className="px-2 pt-4">
        <div className="flex flex-col space-y-1">
          <Line className="h-5 w-3/4" />
          <Line className="h-4 w-1/2" />
        </div>
      </div>
    </div>
  );
}

export function ListLoader() {
  return (
    <div className="items flex flex-col" aria-hidden="true">
      <ListItemLoader />
      <ListItemLoader />
      <ListItemLoader />
    </div>
  );
}

export function CardsLoader() {
  return (
    <div className="items flex flex-col" aria-hidden="true">
      <div className="card-view ml-5 mr-5 grid grid-cols-2 gap-4">
        <CardItemLoader />
        <CardItemLoader />
        <CardItemLoader />
        <CardItemLoader />
      </div>
    </div>
  );
}
